import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, Folder } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  uploadDocument(request: Boundaries["uploadDocument"]["request"]): void;
}

function useUploadDocument(folder: Identifiable<Folder>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUploadDocumentRequestPending(folder),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUploadDocumentRequestSuccess(folder),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUploadDocumentRequestFailure(folder),
    ),
    uploadDocument: core.uploadDocument,
  };
}

export { useUploadDocument };
